export { default } from './Learning.component';
